export const isNumeric = (value: string | number) => Number.isNaN(Number(value));
